import { getNumberWithCommas } from '../../ui/utils/getNumberWithCommas';
export function getInternalRecipientsSummaryLabel(counts, t) {
    let groupText = '';
    let organizationText = '';
    if (counts.groupCount > 0) {
        groupText = t('common.groupsCount', { count: counts.groupCount });
    }
    if (counts.groupAccountsCount > 0) {
        groupText += `${' ' +
            t('pages.edit.recipients.dialog.internalRecipientsCount', {
                totalRecipients: getNumberWithCommas(counts.groupAccountsCount),
            })}`;
    }
    if (counts.organizationCount > 0) {
        organizationText = t('common.organizationsCount', { count: counts.organizationCount });
    }
    if (counts.organizationAccountsCount > 0) {
        organizationText += `${' ' + t('pages.edit.recipients.dialog.internalRecipientsCount', { totalRecipients: getNumberWithCommas(counts.organizationAccountsCount) })}`;
    }
    return { groupText, organizationText };
}
